// @flow
import 'isomorphic-fetch';
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import injectSheet from 'react-jss';
import cx from 'classnames';

import AnimatedHeart from './AnimatedHeart';

type Props = {
  classes: Object,
  galleryId: String,
  imageId: String,
  likeData: Object,
  handleLikeClick: Function,
  userId: String,
  fetchDomain: String,
  isGallery: Boolean,
};

class Like extends Component {
  constructor(props) {
    super(props);
    this.animate = React.createRef();
  }

  props: Props = this.props;

  handleClick = async (e) => {
    e.preventDefault();

    this.animate.current.splash();

    e.stopPropagation();
    const cookies = new Cookies();
    const likedIdList = cookies.get('likedIdList');
    const {
      likeData, handleLikeClick, userId, galleryId, imageId, fetchDomain
    } = this.props;
    const liked = likeData && likeData.liked || false;

    // When clicking like button the first time, the imageId is put into the cookies
    // synchronously, and when click the second time, the cookie will prevent getting
    // into the block.
    if (!liked && !likedIdList.includes(imageId)) {
      likedIdList.push(imageId);
      cookies.set('likedIdList', likedIdList);

      const url = `${fetchDomain}/api/like`;
      const data = {
        galleryId,
        imageId,
        userId
      };

      const res = await fetch(`${url}/gallery`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      const response = await res.json();

      if (response.error) {
        throw Error(response.message);
      }

      handleLikeClick(liked, imageId);
    } // do nothing if user already like the image. only visual animation
  }

  render() {
    const { classes: c, likeData = {}, isGallery } = this.props;

    const { liked = false, count = 0 } = likeData;
    const { handleClick } = this;
    const modifiedCount = count >= 1000 ? `${count / 1000}k` : count;

    return (
      <div
        className={cx(c.container, isGallery && c.top)}
      >
        {liked ? (
          <i
            className="material-icons"
            style={{ color: 'red' }}
            onClick={handleClick}
          >
            favorite
          </i>
        ) : (
          <i
            className="material-icons"
            style={{ color: 'white' }}
            onClick={handleClick}
          >
            favorite_border
          </i>
        )}

        <span className={c.count}>
          {`${modifiedCount}`}
        </span>

        <AnimatedHeart ref={this.animate} deltaY={-8} deltaX={-48} radius={50} count={5} fixed={isGallery} />
      </div>
    );
  }
}

const styles = {
  container: {
    position: 'absolute',
    bottom: '13px',
    right: '13px',
    height: '30px',
    zIndex: 5,
    display: 'flex',
    justifyContent: 'space-between',
    width: '56px',
    alignItems: 'center',
    userSelect: 'none',
    '& > .material-icons': {
      fontSize: '30px',
      cursor: 'pointer',
    },
    '@media only screen and (max-width: 960px) and (orientation: portrait)': {
      // Move icon up to compensate for Chrome mobile page height adjustments (hide-on-scroll address bar and tab bar)
      bottom: '53px',
    },
  },
  top: {
    bottom: '13px',
    right: '13px',
    '@media(max-width: 479px)': {
      top: '13px',
      left: '13px',
    },
  },
  count: {
    color: 'white',
    fontSize: '13px',
    margin: '0 8px',
    textAlign: 'center'
  },
};

export default injectSheet(styles)(Like);
